import { Record } from 'immutable';

export const StoreRecord = Record({
    value: null,
    pending: false,
    error: null
});
